import { createSelector } from 'reselect';

import { initialState } from './reducer';
import { selectActiveProfile } from '../../App/selectors';

const selectSettingsDomain = state => state.AccountSettings || initialState;

const selectUserPayments = () => createSelector(selectSettingsDomain, subState => subState.payments);
const selectProducts = () => createSelector(selectSettingsDomain, subState => subState.products);
const selectUserPaymentMethods = () => createSelector(selectSettingsDomain, subState => subState?.userPaymentMethods);
const selectDefaultUserPaymentMethod = () =>
  createSelector(selectSettingsDomain, subState => subState?.userPaymentMethods?.data?.find(pm => pm?.is_default));
const selectUserSubscriptions = () => createSelector(selectSettingsDomain, subState => subState.userSubscriptions);
const selectActiveProfileSubscriptions = () =>
  createSelector(selectUserSubscriptions(), selectActiveProfile(), (userSubscriptions, activeProfile) =>
    userSubscriptions?.data?.filter(subscription => subscription?.profile?.id === activeProfile?.id),
  );
const selectUserInvoicesList = () => createSelector(selectSettingsDomain, subState => subState.userInvoices);
const selectUserPaymentsList = () => createSelector(selectSettingsDomain, subState => subState.userPayments);

const selectArtistsWorkedWith = () => createSelector(selectSettingsDomain, subState => subState.artistsWorkedWith);

const selectGiftSubscriptions = () => createSelector(selectSettingsDomain, subState => subState.giftSubscriptions);
const selectUserReferrals = () => createSelector(selectSettingsDomain, subState => subState.userReferrals);
const selectUserRewardBalance = () => createSelector(selectSettingsDomain, subState => subState.rewardBalance);

export {
  selectUserPayments,
  selectUserSubscriptions,
  selectUserPaymentMethods,
  selectProducts,
  selectUserInvoicesList,
  selectUserPaymentsList,
  selectActiveProfileSubscriptions,
  selectDefaultUserPaymentMethod,
  selectArtistsWorkedWith,
  selectGiftSubscriptions,
  selectUserReferrals,
  selectUserRewardBalance,
};
